import { ofType } from "redux-observable";
import { delay, mapTo, take } from "rxjs/operators";
import { TypeActionApp } from "../../../app/actionApp";
import { actionGameTrackingUpdateClientFunnel } from "../../actionGameTracking";
import { IdGameTrackingClientFunnelState } from "../IdGameTrackingClientFunnelState";
export var epicGameTrackingClientFunnelAppStart = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionApp.Init), take(1), delay(1), mapTo(actionGameTrackingUpdateClientFunnel(IdGameTrackingClientFunnelState.LOADING_STEP_APP_START)));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/game-tracking/game-funnel/epics/epicGameTrackingClientFunnelAppStart.ts
// module id = 1869
// module chunks = 3